// extracted by mini-css-extract-plugin
export default {"tag":"StatusTag_tag__DIKQ2","dot":"StatusTag_dot__6F3pJ","active":"StatusTag_active__wYNt-","archived":"StatusTag_archived__vLkf9","draft":"StatusTag_draft__3tOPn"};